<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
    >
      <el-form-item label="预警类型">
        <el-select v-model="formModel.commodityType">
          <el-option
            v-for="item in TopGoodsTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="dictValue"
        label="预警类型"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="thresholdValue"
        label="阀值"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="smsPhone"
        label="收件人手机号"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改</el-button
          >
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @success="dialogSuccess"
      @close="dialogClose"
      class="note"
    >
      <el-form-item label="预警类型" prop="warningType">
        <el-select v-model="dialogModel.warningType">
          <el-option
            v-for="item in GoodsTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="阀值"
        prop="thresholdValue"
        v-if="dialogModel.warningType == '0'"
      >
        <el-input
          type="text"
          maxlength="3"
          v-model.number="dialogModel.thresholdValue"
          placeholder="请输入"
        ></el-input>
        <span>%</span>
      </el-form-item>
      <el-form-item
        label="阀值"
        prop="thresholdValue"
        v-if="dialogModel.warningType == '1'"
      >
        <el-input
          type="text"
          maxlength="3"
          v-model.number="dialogModel.thresholdValue"
          placeholder="请输入"
        ></el-input>
        <span>条</span>
      </el-form-item>
      <el-form-item label="手机号" prop="smsPhone">
        <el-input
          type="textarea"
          v-model="dialogModel.smsPhone"
          rows="3"
          placeholder="请输入手机号，多个号码以‘,’分割"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import MallService from "service/MallService";
import TimeRange from "service/constant/TimeRange";

import Regs from "common/conf/Regs";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "goodstypemanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value);
      if (!boolean) {
        this.dialogRules.thresholdValue[0].message = "请输入正整数";
        this.this.dialogModel.thresholdValue = "";
      } else {
        this.dialogRules.thresholdValue[0].message = "请输入";
      }
    };
    return {
      GoodsTypes: [],
      TopGoodsTypes: [],
      formModel: {
        commodityType: "",
        time: "",
      },
      tableData: [],
      submitService: MallService.smsList,
      page: {},
      isPage: false,
      itemId: "",
      bbb: "",
      dialogModel: {
        warningType: "",
        thresholdValue: "",
        // thresholdValues: "",
        smsPhone: "",
      },
      dialogRules: {
        warningType: [
          {
            required: true,
            message: "请选择预警类型",
          },
        ],
        thresholdValue: [
          {
            required: true,
            message: "请输入阀值",
            validator: blurText,
          },
        ],
        // thresholdValues: [
        //   {
        //     required: true,
        //     message: "请输入阀值",
        //     // validator: blurText,
        //   },
        // ],
        smsPhone: [
          {
            required: true,
            message: "请输入手机号",
          },
        ],
      },
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        warningType: this.formModel.commodityType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        // 0代表开始时间
        this.params.createTimeStart = this.formModel.time[0];
        // 1代表结束时间
        this.params.createTimeEnd = this.formModel.time[1];
      }
      return this.params;
    },
    dialogData() {
      const params = {
        // 提交对数据拼接
        warningType: this.dialogModel.warningType,
        thresholdValue: this.dialogModel.thresholdValue,
        // thresholdValue: this.dialogModel.thresholdValues,
        smsPhone: this.dialogModel.smsPhone,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId ? MallService.smsEdit : MallService.smsInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    // "dialogModel.warningType"(newValue, oldValue) {
    //   if (newValue == 0) {
    //     if (!this.isPage) {
    //       this.dialogModel.thresholdValues = "";
    //     }
    //     this.isFlag = false;
    //   }
    //   if (newValue == 1) {
    //     if (!this.isPage) {
    //       this.dialogModel.thresholdValue = "";
    //     }
    //     this.isFlag = false;
    //   }
    // },
  },
  methods: {
    load() {
      this.formModel = {
        commodityType: "",
        time: "",
      };

      this.page = this.$refs.commonTable.page;

      this.getGoodsTypes();
      this.getList();
    },
    getGoodsTypes(val) {
      this.doLoad(
        MallService.smsTypes,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.TopGoodsTypes = [
              {
                dictKey: "",
                dictValue: "全部",
              },
              ...res.contents,
            ];
            this.GoodsTypes = res.contents;
          });
        },
        "操作失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleDelete(item) {
      this.showConfirm("确定删除此数据？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        MallService.smsDelete,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    dialogClose() {
      this.dialogModel = {
        warningType: "",
        thresholdValue: "",
        smsPhone: "",
      };
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/SmsWarning.vue